// client_app/contexts/HighlightContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";

import { Feature } from "@/client_app/hooks/useApplyHighlights";

const HighlightContext = createContext<Feature[]>([]);

export const HighlightProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [features, setFeatures] = useState<Feature[]>([]);

  useEffect(() => {
    const node = document.getElementById("context-data");
    const raw = node?.getAttribute("data-highlight-broadcast-features-value");
    if (!raw) return;

    try {
      const parsed: Feature[] = JSON.parse(raw);
      setFeatures(parsed);
    } catch (e) {
      console.error("Failed to parse highlight features", e);
    }
  }, []);

  return (
    <HighlightContext.Provider value={features}>
      {children}
    </HighlightContext.Provider>
  );
};

export const useHighlights = (): Feature[] => {
  return useContext(HighlightContext);
};
